import type { SignatureFeature } from '../types';

type Props = {
  features: SignatureFeature[];
};

export default function SignatureFeatures({ features }: Props) {
  return (
    <section className="bg-background-100/50 py-20 md:py-32 border-y border-background-200/70">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="mb-14 md:mb-20">
          <h2 className="font-heading text-foreground-950 text-4xl md:text-5xl leading-[1.07] tracking-[-0.01em] max-w-xl">
            The things that make
            <span className="block italic font-light text-foreground-600"> this property remarkable.</span>
          </h2>
        </div>

        <div className="space-y-20 md:space-y-28">
          {features.map((f, i) => (
            <div
              key={f.title}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center`}
            >
              <div className={i % 2 === 1 ? 'lg:order-2' : ''}>
                <div className="relative overflow-hidden rounded-2xl aspect-[4/3] bg-background-200 w-full h-full">
                  <img
                    src={f.image}
                    alt={f.imageAlt}
                    className="absolute inset-0 w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className={i % 2 === 1 ? 'lg:order-1' : ''}>
                <h3 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-tight mb-5">
                  {f.title}
                </h3>
                <p className="text-foreground-600 text-base md:text-lg font-light leading-relaxed max-w-lg">
                  {f.body}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
